export const iconSize = { height: 18, width: 18 };
